import API from '@/models/API';

export default class Transaction {
  constructor(item = {}) {
    this.transaction_id = item.transaction_id || null;
    this.user = item.user || null;
    this.country_id = item.country_id || null;
    this.receipt_number = item.receipt_number || null;
    this.voucher = item.voucher || null;
    this.amount = item.amount || null;
    this.is_online_transaction = item.is_online_transaction || false;
    this.products = item.products || [];
    this.general_coupon_claims_for_use = item.general_coupon_claims_for_use || [];
    this.sampling_coupons_for_use = item.sampling_coupons_for_use || [];
    this.company_information = item.company_information || undefined;
  }

  static clearFalsyValues = (obj) => {
    for (let key in obj) {
      if (!obj[key]) {
        delete obj[key];
      } else if (typeof obj[key] === 'object') {
        if (obj[key].length === 0) delete obj[key];
      }
    }
  };

  static getProducts = (query) =>
    API.get(`/stores/${localStorage.getItem('storeId')}/products${query || ''}`);

  static getLastZDownload = () =>
    API.get(`/stores/${localStorage.getItem('storeId')}/last-z/download`);

  static getLast24Revenue = () =>
    API.get(`/stores/${localStorage.getItem('storeId')}/transactions/online-last24`);

  static getTransactionPreview = (item) =>
    API.post(`/stores/${localStorage.getItem('storeId')}/transactions/transaction-preview`, item);

  static getTransactionStatuses = () => API.get(`/common/transaction-statuses`);

  static getTransactionTypes = () => API.get(`/common/transaction-types`);

  static get = (query) =>
    API.get(`/stores/${localStorage.getItem('storeId')}/transactions${query}`);

  static getItem = (id) => API.get(`/stores/${localStorage.getItem('storeId')}/transactions/${id}`);

  static create = (item, uuid) =>
    API.post(
      `/stores/${localStorage.getItem('storeId')}/transactions/new-in-store-transaction`,
      item,
      {
        headers: {
          Idempotency: uuid,
        },
      }
    );

  static updateMobilePayments = (item) =>
    API.put(`/stores/${localStorage.getItem('storeId')}/flags/reward`, item);

  static changeStatus = (item) =>
    API.put(
      `/stores/${localStorage.getItem('storeId')}/transactions/${
        item.transaction_id
      }/change-status`,
      { transaction_status_id: item.transaction_status_id }
    );

  static refundTransaction = (item) =>
    API.post(`/stores/${localStorage.getItem('storeId')}/transactions/cancel-transaction`, item);

  static cancelTransaction = (item) =>
    API.post(
      `/stores/${localStorage.getItem('storeId')}/transactions/cancel-offline-transaction`,
      item
    );

  static claimCoupon = (body) =>
    API.post(`/stores/${localStorage.getItem('storeId')}/transactions/coupon-claim`, body);

  static sendVerificationCode = (body, uuid) =>
    API.post(
      `/stores/${localStorage.getItem('storeId')}/transactions/new-in-store-transaction-identifier`,
      body,
      {
        headers: {
          Idempotency: uuid,
        },
      }
    );

  static validateReceiptNumber = (body) =>
    API.post(
      `/stores/${localStorage.getItem('storeId')}/transactions/validate/receipt-cash-register`,
      body
    );

  static validateReceiptIdentifier = (body) =>
    API.post(`/stores/${localStorage.getItem('storeId')}/transactions/validate/receipt`, body);

  static getCouponVerificationCode = (body) =>
    API.post(
      `/stores/${localStorage.getItem('storeId')}/transactions/coupon-claim/verification`,
      body
    );

  static confirmCouponVerificationCode = (body) =>
    API.post(`/stores/${localStorage.getItem('storeId')}/transactions/coupon-claim/confirm`, body);

  static updateCustomer = (id, body) =>
    API.put(`/stores/${localStorage.getItem('storeId')}/customers/${id}`, body);

  static getCustomerDetails = (id) =>
    API.get(`/stores/${localStorage.getItem('storeId')}/customers/${id}`);

  static getAttributes = () =>
    API.get(`/stores/${localStorage.getItem('storeId')}/attributes/definitions`);

  static updateOrdersAllowed = (body) =>
    API.put(`/stores/${localStorage.getItem('storeId')}/flags/reward`, body);
}
